import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { FaFileAlt, FaClock, FaArrowRight } from 'react-icons/fa';
import { empresaService, empleadosService } from '../services/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [empresaStats, setEmpresaStats] = useState({
    validos: 0,
    noValidos: 0,
    sinPresentar: 0,
    caducidadProxima: 0,
    caducados: 0
  });
  const [trabajadoresStats, setTrabajadoresStats] = useState({
    validos: 0,
    noValidos: 0,
    sinPresentar: 0,
    caducidadProxima: 0,
    caducados: 0
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    setLoading(true);
    try {
      // Cargar estadísticas de empresa
      const empresaResponse = await empresaService.getDocumentStats();
      if (empresaResponse.data.success) {
        setEmpresaStats(empresaResponse.data.stats);
      }

      // Cargar estadísticas de trabajadores
      const trabajadoresResponse = await empleadosService.getDocumentStats();
      if (trabajadoresResponse.data.success) {
        setTrabajadoresStats(trabajadoresResponse.data.stats);
      }
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
      toast.error('Error al cargar las estadísticas');
    } finally {
      setLoading(false);
    }
  };

  const StatCard = ({ title, value, color, icon: Icon, onDetailClick }) => {
    const colorClasses = {
      green: { bg: '#28a745', icon: '#1e7e34', text: 'text-white' },
      red: { bg: '#dc3545', icon: '#a71e2a', text: 'text-white' },
      orange: { bg: '#fd7e14', icon: '#c85e0a', text: 'text-white' }
    };

    const colors = colorClasses[color] || colorClasses.green;

    return (
      <Card
        style={{
          backgroundColor: colors.bg,
          color: 'white',
          height: '100%',
          position: 'relative',
          overflow: 'hidden'
        }}
        className="mb-3"
      >
        <Card.Body className="d-flex flex-column" style={{ minHeight: '200px' }}>
          {/* Icono en la esquina superior derecha */}
          <div style={{ position: 'absolute', top: '15px', right: '15px', opacity: 0.3 }}>
            <Icon size={60} color={colors.icon} />
          </div>

          {/* Número grande */}
          <div className="text-center mb-3" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h1 style={{ fontSize: '4rem', fontWeight: 'bold', margin: 0, color: 'white' }}>
              {value}
            </h1>
          </div>

          {/* Texto descriptivo */}
          <div className="text-center mb-3">
            <h5 style={{ color: 'white', fontWeight: 'normal', margin: 0 }}>
              {title}
            </h5>
          </div>

          {/* Botón Detalle */}
          <div className="text-center">
            <Button
              variant="light"
              size="sm"
              onClick={onDetailClick}
              style={{
                backgroundColor: 'white',
                color: colors.bg,
                border: 'none',
                fontWeight: 'bold'
              }}
            >
              Detalle <FaArrowRight className="ms-1" />
            </Button>
          </div>
        </Card.Body>
      </Card>
    );
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
        <p className="mt-2">Cargando estadísticas...</p>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">
      <h2 className="mb-4">Dashboard</h2>

      {/* Sección de Documentos de Empresa */}
      <div className="mb-5">
        <h3 className="mb-4">Documentos de Empresa</h3>
        <Row>
          <Col md={4} lg={2.4} className="mb-3">
            <StatCard
              title="Documentos válidos"
              value={empresaStats.validos}
              color="green"
              icon={FaFileAlt}
              onDetailClick={() => navigate('/empresa')}
            />
          </Col>
          <Col md={4} lg={2.4} className="mb-3">
            <StatCard
              title="Documentos no válidos"
              value={empresaStats.noValidos}
              color="red"
              icon={FaFileAlt}
              onDetailClick={() => navigate('/empresa')}
            />
          </Col>
          <Col md={4} lg={2.4} className="mb-3">
            <StatCard
              title="Documentos sin presentar"
              value={empresaStats.sinPresentar}
              color="red"
              icon={FaFileAlt}
              onDetailClick={() => navigate('/empresa')}
            />
          </Col>
          <Col md={4} lg={2.4} className="mb-3">
            <StatCard
              title="Caducidad próxima"
              value={empresaStats.caducidadProxima}
              color="orange"
              icon={FaClock}
              onDetailClick={() => navigate('/empresa')}
            />
          </Col>
          <Col md={4} lg={2.4} className="mb-3">
            <StatCard
              title="Documentos caducados"
              value={empresaStats.caducados}
              color="red"
              icon={FaClock}
              onDetailClick={() => navigate('/empresa')}
            />
          </Col>
        </Row>
      </div>

      {/* Sección de Documentos de Trabajadores */}
      <div className="mb-5">
        <h3 className="mb-4">Documentos de Trabajadores</h3>
        <Row>
          <Col md={4} lg={2.4} className="mb-3">
            <StatCard
              title="Documentos válidos"
              value={trabajadoresStats.validos}
              color="green"
              icon={FaFileAlt}
              onDetailClick={() => navigate('/empleados?documentStatus=0')}
            />
          </Col>
          <Col md={4} lg={2.4} className="mb-3">
            <StatCard
              title="Documentos no válidos"
              value={trabajadoresStats.noValidos}
              color="red"
              icon={FaFileAlt}
              onDetailClick={() => navigate('/empleados?documentStatus=1')}
            />
          </Col>
          <Col md={4} lg={2.4} className="mb-3">
            <StatCard
              title="Documentos sin presentar"
              value={trabajadoresStats.sinPresentar}
              color="red"
              icon={FaFileAlt}
              onDetailClick={() => navigate('/empleados?documentStatus=2')}
            />
          </Col>
          <Col md={4} lg={2.4} className="mb-3">
            <StatCard
              title="Caducidad próxima"
              value={trabajadoresStats.caducidadProxima}
              color="orange"
              icon={FaClock}
              onDetailClick={() => navigate('/empleados?documentStatus=3')}
            />
          </Col>
          <Col md={4} lg={2.4} className="mb-3">
            <StatCard
              title="Documentos caducados"
              value={trabajadoresStats.caducados}
              color="red"
              icon={FaClock}
              onDetailClick={() => navigate('/empleados?documentStatus=4')}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Dashboard;
